import React, {useContext} from 'react';
import {handleImageUrl, slugify} from "../../helpers";
import {Link} from "react-router-dom";
import {LangContext} from "../../App";

const RestaurantItem = ({path,tour}) => {
    const lang = useContext(LangContext)
    const slug = slugify(tour?.title || '')
    const image = handleImageUrl(tour.thumbnail)
    return (
        <Link to={`/${lang}/${path}/${tour.id}/${slug}`} className='restaurant-item'>
            {image && <img src={image} alt={tour.title} />}
            <h2>{tour.title}</h2>
            <p>{tour.description}</p>
        </Link>
    );
};

export default RestaurantItem;